import { style } from 'typestyle'
import { important } from 'csx'
export const br42i = style({ borderRadius: important('42px') })
